import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { PUBLIC_URL } from '../environment'
import { canNavigatorShare, isBasicShareCapable } from '../utils/nativeSharing'
import { BuildConfig } from '../config/BuildConfig'

const SharedListLinkPopup: React.FunctionComponent<{ id: string, onClose: () => void }> = ({ id, onClose }) => {
  const linkTextRef = React.useRef<HTMLInputElement | null>(null)
  const shareUrl = `${window.location.origin}${PUBLIC_URL}/list/${id}`

  const nav = navigator

  const [isCopied, setIsCopied] = React.useState(false)

  React.useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false)
      }, 2000)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [isCopied])

  const sharePayload = {
    title: `My ${BuildConfig.brand.brandName} Iconic List`,
    text: `Check out my ${BuildConfig.brand.brandName} Iconic list`,
    url: shareUrl,
  }

  return (
    <Popup onClose={onClose}>
      <div className="title">
        Share your List
      </div>
      <div className="subtitle">
        Your list has been saved.
        <br/>You can share this link with anyone, and they&apos;ll be able to view your list.
      </div>

      <div className="buttonStack">
        <input
          ref={linkTextRef}
          type="text"
          readOnly
          value={shareUrl}
        />

        {/*<a href={`mailto:?subject=Iconic List&body=${encodeURIComponent(shareUrl)}`}>*/}
        {/*  email it*/}
        {/*</a>*/}

        <Button
          buttonStyle="green"
          onClick={() => {
            if (isCopied) {
              setIsCopied(false)
            } else if (linkTextRef.current && !isCopied) {
              linkTextRef.current.select()
              if (document.execCommand('copy')) {
                setIsCopied(true)
              }
            }
          }}
        >
          {
            isCopied ? 'Link copied!' : 'Copy link'
          }
        </Button>

        {
          isBasicShareCapable(nav) && canNavigatorShare(nav, sharePayload) && (
            <Button
              onClick={() => {
                nav.share(sharePayload)
                  .then(() => console.info('Successful share', sharePayload))
                  .catch((err: any) => console.error('Error sharing', err))
              }}
            >
              Share link
            </Button>
          )
        }

        <Button
          onClick={() => { window.open(shareUrl) }}
        >
          View my shared List
        </Button>

        <div style={{ marginBottom: '10px' }} />

        <Button
          buttonStyle="link"
          onClick={() => onClose()}
        >
          Done
        </Button>
      </div>
    </Popup>
  )
}

export default SharedListLinkPopup
